import gql from 'graphql-tag';

const MOVE_PROJECT_CATEGORY = gql`
  mutation moveProjectCategory (
    $data: ProjectCategoryMoveInput!
  ) {
    moveProjectCategory (data: $data) {
      id
      parentId
      path
      sortOrder
      level
    }
  }
`;

export default MOVE_PROJECT_CATEGORY;
